import React from 'react';
import {Document, Image, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import {TOTAL} from '../../../common/constants.js';

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#d6f4ff',
        padding: 20,
        fontSize: 11,
    },
    sectionTitle: {
        fontSize: 16,
        marginTop: 16,
        marginBottom: 6,
        fontWeight: 'bold'
    },
    content: {
        backgroundColor: '#ffffff',
        padding: 10,
        marginTop: 8
    },
    container: {
        padding: 10,
        marginBottom: 4,
        borderRadius: 4,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 4,
    },
    question: {
        width: '80%',
        fontWeight: 'bold',
    },
    answer: {
        width: '20%',
        textAlign: 'right',
        fontWeight: 'bold',
        marginRight: 8
    },
    commentBox: {
        backgroundColor: '#c8f4c5',
        padding: 6,
        marginTop: 6,
        borderRadius: 3,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 12,
    },
    summaryContainer: {
        backgroundColor: '#fff',
        padding: 8
    },
    chapterRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#ccc',
    },
    chapterLabel: {
        width: '70%',
        fontWeight: 'bold'
    },
    chapterScoreBox: {
        width: '30%',
        flexDirection: 'column',
        alignItems: 'center'
    },
    chapterScoreValue: {
        color: '#fff',
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderRadius: 50,
        fontSize: 12,
    },
    chapterScoreText: {
        fontSize: 10,
        marginTop: 4
    },
    chartImage: {
        width: 562,
        marginBottom: 10,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: '#fff'
    },
    footer: {
        position: 'absolute',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#555',
    },
});

const getBgColor = (value) => {
    if (value < 80) return "#EA4228";
    if (value < 85) return "#F5CD19";
    return "#5BE12C";
};

const removeTotalScore = score =>
    score?.filter(item => item.score_type !== TOTAL) ?? [];

const PdfDocument = ({leadData, rowData, chartImage}) => (
    <Document>
        <Page size="A4" style={styles.page} wrap>

            <Text
                style={styles.footer}
                render={({pageNumber, totalPages}) =>
                    `Page ${pageNumber} / ${totalPages}`
                }
                fixed
            />

            <Text style={styles.title}>Audit Lead Details</Text>

            <Text>Lead ID: {rowData.lead_id}</Text>
            <Text>Merchant Name: {rowData.merchant_name}</Text>
            <Text>Merchant number: {rowData.merchant_number}</Text>

            <Text style={styles.sectionTitle}>Final Grade</Text>
            <Image src={chartImage} style={styles.chartImage}/>

            <Text style={styles.sectionTitle}>Chapters summary</Text>

            <View style={styles.summaryContainer}>
                {removeTotalScore(leadData?.score).map((item, index) => (
                    <View key={index} style={styles.chapterRow}>
                        <Text style={styles.chapterLabel}>{item.score_type}</Text>

                        <View style={styles.chapterScoreBox}>
                            <Text
                                style={[
                                    styles.chapterScoreValue,
                                    {backgroundColor: getBgColor(item.value)}
                                ]}
                            >
                                {item.value}
                            </Text>
                            <Text style={styles.chapterScoreText}>{item.score}</Text>
                        </View>
                    </View>
                ))}
            </View>

            <View style={styles.content}>
                {leadData?.questions?.map((item, index) => (
                    <View key={index} style={styles.container}>

                        <View style={styles.row}>
                            <Text style={styles.question}>{item.question}</Text>
                            <Text style={styles.answer}>
                                {item.answer?.replace(/[\[\]]/g, '')}
                            </Text>
                        </View>

                        {item.comment && (
                            <View style={styles.commentBox}>
                                <Text>{item.comment}</Text>
                            </View>
                        )}

                        {item.image && (
                            <Image
                                src={item.image}
                                style={{
                                    width: 200,
                                    height: 200,
                                    marginTop: 6,
                                    borderRadius: 4,
                                }}
                            />
                        )}
                    </View>
                ))}
            </View>

        </Page>
    </Document>
);

export default PdfDocument;
